"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTargetVisible = exports.isSectionVisible = exports.isQuestionVisible = exports.getVisibleQuestionIds = void 0;
var types_1 = require("../../types");
var getVisibleQuestionIds = function (sections, responses, displayConditions) {
    var visibleQuestionIds = new Set();
    sections.forEach(function (s) {
        if (s.rootId && exports.isSectionVisible(s.rootId, responses, displayConditions)) {
            s.items.forEach(function (item) {
                if (item.type === "QUESTION" &&
                    exports.isQuestionVisible(item.rootId, s.rootId, responses, displayConditions)) {
                    visibleQuestionIds.add(item.id);
                }
            });
        }
    });
    return visibleQuestionIds;
};
exports.getVisibleQuestionIds = getVisibleQuestionIds;
var isQuestionVisible = function (questionRootId, sectionRootId, responses, displayConditions) {
    return (exports.isSectionVisible(sectionRootId, responses, displayConditions) &&
        exports.isTargetVisible(questionRootId, "QUESTION", responses, displayConditions));
};
exports.isQuestionVisible = isQuestionVisible;
var isSectionVisible = function (sectionRootId, responses, displayConditions) {
    return exports.isTargetVisible(sectionRootId, "SECTION", responses, displayConditions);
};
exports.isSectionVisible = isSectionVisible;
var isTargetVisible = function (targetRootId, targetType, responses, displayConditions) {
    if (!displayConditions) {
        return true;
    }
    var conditions = displayConditions
        .filter(types_1.isShowHideDisplayCondition)
        .filter(function (c) { return c.targetType === targetType && c.targetRootId === targetRootId; });
    if (conditions.length === 0) {
        return true;
    }
    var actions = new Set(conditions.map(function (c) { return c.action; }));
    if (actions.size > 1) {
        console.warn("Display conditions for target " + targetRootId + " have mismatched actions - choosing first");
    }
    var action = actions.values().next().value;
    var matches = conditions.some(function (c) { return conditionMatches(c, responses); });
    switch (action) {
        case "SHOW":
            return matches;
        case "HIDE":
        default:
            return !matches;
    }
};
exports.isTargetVisible = isTargetVisible;
var conditionMatches = function (condition, allResponses) {
    if (condition.booleanCondition === undefined &&
        condition.sourceConditionRootId === undefined) {
        return false;
    }
    var responses = allResponses.filter(function (r) { return r.questionRootId === condition.sourceQuestionRootId; });
    if (responses.length === 0) {
        return false;
    }
    if (condition.sourceConditionRootId !== undefined &&
        condition.sourceConditionRootId !== null) {
        return responses.some(function (r) { return r.associatedRootId === condition.sourceConditionRootId; });
    }
    if (condition.booleanCondition !== undefined) {
        return responses.some(function (r) {
            var _a;
            return condition.booleanCondition !== undefined &&
                r.answer === ((_a = condition.booleanCondition) === null || _a === void 0 ? void 0 : _a.toString());
        });
    }
    console.error("Something is wrong with display condition ", condition);
    return false;
};
//# sourceMappingURL=showHide.js.map